// Validation patterns for Company Contacts
export const ValidationPatterns = {
  NAME: /^[a-zA-Z0-9\s\-'\.]+$/,
  PHONE: /^[\+]?[1-9][\d]{0,15}$/,
  BUSINESS_TITLE: /^[a-zA-Z0-9\s\-'\.&,()\/]+$/,
  // Allow international phone formats with common separators
  PHONE_FLEXIBLE: /^[\+]?[\d\s\-\(\)\.]{7,20}$/
};

// Validation error messages
export const ValidationMessages = {
  REQUIRED: "Required.",
  NAME_MIN_LENGTH: "Name must be at least 2 characters.",
  NAME_MAX_LENGTH: "Name cannot exceed 100 characters.",
  NAME_INVALID_CHARS: "Name can only contain letters, numbers, spaces, hyphens, apostrophes, and periods.",
  BUSINESS_TITLE_MAX_LENGTH: "Business title cannot exceed 100 characters.",
  BUSINESS_TITLE_INVALID_CHARS: "Business title contains invalid characters.",
  EMAIL_MAX_LENGTH: "Email cannot exceed 100 characters.",
  EMAIL_INVALID_FORMAT: "Please enter a valid email format.",
  EMAIL_CORPORATE_ONLY: "Only business emails are allowed. Personal email addresses are prohibited.",
  PHONE_MAX_LENGTH: "Phone number cannot exceed 20 characters.",
  PHONE_INVALID_FORMAT: "Please enter a valid phone number format.",
  FORM_VALIDATION_FAILED: "Please correct the validation errors before submitting.",
  CONTACT_PARTIAL_DATA: "When providing contact information, First Name, Last Name, and Business Email are required."
};

// Field length limits
export const FieldLimits = {
  NAME_MIN: 2,
  NAME_MAX: 100,
  BUSINESS_TITLE_MAX: 100,
  EMAIL_MAX: 100,
  PHONE_MAX: 20
};

// Contact section display names for better error messages
export const ContactSectionNames = {
  technicalContactOne: "Technical Contact 1",
  technicalContactTwo: "Technical Contact 2",
  businessContactOne: "Business Contact 1",
  businessContactTwo: "Business Contact 2",
  operationContactOne: "Operation Contact 1",
  operationContactTwo: "Operation Contact 2",
  certificateContactOne: "Certificate Contact 1",
  certificateContactTwo: "Certificate Contact 2",
  certificateTestContactOne: "Certification Test Contact 1",
  certificateTestContactTwo: "Certification Test Contact 2"
};
